export function TableNullField() {
  return <span className="text-gray-300">—</span>;
}
